export function formatFCFA(amount) {
  if (amount == null || isNaN(amount)) return "0 FCFA";
  return Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " FCFA";
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export const ROLE_LABELS = {
  principal_admin: "Administrateur Principal",
  finance_agent: "Agent Financier",
  school_admin: "Administrateur Etablissement",
};

export const METHOD_LABELS = {
  wave: "Wave",
  orange_money: "Orange Money",
  bank_transfer: "Virement bancaire",
  cash: "Especes",
};

export const STATUS_LABELS = {
  paid: "Paye",
  approved: "Valide",
  pending: "En attente",
  rejected: "Rejete",
  partial: "Paiement partiel",
  overdue: "En retard",
  sent: "Emise",
  active: "Actif",
  draft: "Brouillon",
};
